import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Fragment } from 'react';
import { useCss } from '../../system';
import DragDrop from '../../DragDrop';
import { getCell, getRowLinkProps } from '../utils';
import BodyRow from './BodyRow';
import BodySubRows from './BodySubRows';

function BodyRows(_ref) {
  var columns = _ref.columns,
      columnWidths = _ref.columnWidths,
      data = _ref.data,
      draggable = _ref.draggable,
      getColumnRef = _ref.getColumnRef,
      getRowId = _ref.getRowId,
      getRowLink = _ref.getRowLink,
      getSubData = _ref.getSubData,
      getVariant = _ref.getVariant,
      keyboardShortcuts = _ref.keyboardShortcuts,
      onRowClick = _ref.onRowClick;
  var css = useCss();
  return data.map(function (rowData, rowIndex) {
    var getCells = function getCells(_dragHandleProps) {
      return columns.map(function (column, columnIndex) {
        var cellVariantStyles = getVariant('bodyCell', {
          rowData: rowData,
          rowIndex: rowIndex,
          columnIndex: columnIndex,
          firstRow: rowIndex === 0,
          lastRow: rowIndex === Math.max(0, data.length - 1),
          firstCell: columnIndex === 0,
          lastCell: columnIndex === Math.max(0, columns.length - 1)
        });
        return /*#__PURE__*/React.createElement("div", {
          key: columnIndex,
          ref: getColumnRef(columnIndex + "." + (rowIndex + 1)) // offset by 1 to account for header row
          ,
          role: "cell",
          className: "uikit-reset " + css([].concat(cellVariantStyles, [column.css]))
        }, getCell(column.cell, {
          columnIndex: columnIndex,
          rowData: rowData,
          rowIndex: rowIndex,
          _dragHandleProps: _dragHandleProps
        }));
      });
    };

    var rowId = getRowId(rowData, rowIndex);
    var rowVariantClassName = getVariant('bodyRow', {
      rowData: rowData,
      rowIndex: rowIndex,
      isLink: Boolean(getRowLink) || Boolean(onRowClick),
      firstRow: rowIndex === 0,
      lastRow: rowIndex === Math.max(0, data.length - 1),
      evenRow: rowIndex % 2 === 0,
      oddRow: Math.abs(rowIndex % 2) === 1
    });

    var rowProps = _objectSpread({
      rowData: rowData,
      rowIndex: rowIndex,
      keyboardShortcuts: keyboardShortcuts,
      onRowClick: onRowClick,
      className: "uikit-reset " + css(rowVariantClassName)
    }, getRowLinkProps({
      getRowLink: getRowLink,
      data: rowData,
      isSubRow: false
    }));

    var subRowData = getSubData ? getSubData(rowData) : null;
    var subRows = subRowData && /*#__PURE__*/React.createElement(BodySubRows, {
      columns: columns,
      data: subRowData,
      getColumnRef: getColumnRef,
      getRowLink: getRowLink,
      getVariant: getVariant,
      keyboardShortcuts: keyboardShortcuts,
      columnWidths: columnWidths,
      parentRowIndex: rowIndex
    });

    if (draggable) {
      return /*#__PURE__*/React.createElement(DragDrop.Draggable, {
        key: rowId,
        draggableId: rowId.toString(),
        index: rowIndex,
        data: rowData,
        placeholder: function placeholder() {
          return /*#__PURE__*/React.createElement(BodyRow, _extends({}, rowProps, {
            placeholder: true
          }), getCells({}));
        }
      }, function (provided) {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(BodyRow, _extends({
          innerRef: provided.innerRef
        }, provided.draggableProps, rowProps), getCells(provided.dragHandleProps)), subRows);
      });
    } else {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: rowId
      }, /*#__PURE__*/React.createElement(BodyRow, rowProps, getCells()), subRows);
    }
  });
}

export default BodyRows;